module.exports = __webpack_public_path__ + "media/images/emoticons/leo-2b7eece440614780b83e274fc94e93ea.gif";